import React from 'react';
import { connect } from 'react-redux';
import PrimaryForm from '../PrimaryForm/PrimaryForm';
import SecondaryForm from '../SecondaryForm/SecondaryForm';
import { getConfigList, setSelectedValues, setMappings, setHeadings, updateStep } from '../../../redux/actions/IC/ICActions';

class AddICConfig extends React.Component {

  componentDidMount() {
    this.props.getConfigList();
    this.props.setSelectedValues({});
    this.props.setMappings({});
    this.props.setHeadings([]);
    this.props.updateStep(1);
  }

  render() {

    let displayedForm;

    if(this.props.ICREDUCER.update_step === 2) {
      displayedForm = <SecondaryForm from="add" />
    }
    else {
      displayedForm = <PrimaryForm from="add" />
    }

    return (
      displayedForm      
    );
  }
}

function mapStateToProps(state) {
  return state;
}

const mapDispatchToProps = {
  getConfigList,
  setSelectedValues,
  setMappings,
  setHeadings,
  updateStep
};

export default connect(mapStateToProps, mapDispatchToProps)(AddICConfig);


// WEBPACK FOOTER //
// ./src/components/IC/AddICConfig/AddICConfig.js